import { projectWorkingBranchQuery } from '@common/queries/git';
import { Entity } from '@common/types/Entity';

import { useGraphQlQuery } from '../../data/util';

export const useProjectBranchQuery = (projectId: string) => {
  const { data, isInitialLoading } = useGraphQlQuery(
    [Entity.Project],
    projectWorkingBranchQuery,
    {
      enabled: Boolean(projectId)
    },
    { projectId }
  );
  const branch = data?.Project?.listBranches?.workingBranch || '';
  return { isInitialLoading, branch };
};
